import React, { useEffect, useState } from "react";
import {
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Modal,
  Fade,
  Box,
  Grid,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import FormatterChecker from "./FormatChecker";
import { useNavigate } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import {
  startOverAPICall,
  documentupdateAPICall,
  getDocumentTypeDropDownAPICall,
  stageDetailsAPICall,
  CommonDropDownAPICall,
} from "../shared/APICalls";
import routesData from "../shared/routes.json";
import StageLayout from "../Layouts/StageLayout";
import PreviewModalPopup from "../Components/Modals/PreviewModalPopup";
import uploadStyles from "../pages/Styles/Uploads.module.scss";
import icon from "../Components/assets/Images/iconnew.svg";
import passporticon from "../Components/assets/Images/passporticon.svg";
import panicon from "../Components/assets/Images/panicon.svg";
import sigicon from "../Components/assets/Images/sigicon.svg";
import SnackBar from "../Components/SnackBars/SnackBar";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import StartOverBackDrop from "../Components/StartOverBackDrop";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import BackDrop from "../Components/BackDrop";
import ErrorSnackBar from "../Components/SnackBars/ErrorSnackBar";
import { UploadSizes } from "../shared/constants";
import { confirmAlert } from "react-confirm-alert";
import backicon from "../Components/assets/Images/back.svg";
import keyboardicon from "../Components/assets/Images/uploadicongrey.svg";
import FormatterCheckerBankProof from "./FormatCheckerBankProof";
import { useDispatch } from "react-redux";
import {
  setCompletedStages,
  setCurrentStage,
} from "../Components/redux/actions/pathNameActions";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vW",
  height: "80vH",
  bgcolor: "background.paper",
  p: 1,
  boxShadow: 24,
};

export default function UploadDocumentsPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setloading] = useState(false);
  const [message, setmessage] = React.useState("");
  const [infoMessage, setinfoMessage] = React.useState(false);
  const [incomeProofDropdown, setincomeProofDropdown] = useState<any>([]);
  const [incomeProofDocRef, setincomeProofDocRef] = useState<any>();
  const [signatureDocRef, setSignatureDocRef] = useState<any>();
  const [panCardDocRef, setPanCardDocRef] = useState<any>();
  const [showUpload, setShowUpload] = useState(false);
  const [disableContinueOption1, setdisableContinueOption1] = useState("Document uploaded successfully");
  const [disableContinueOption2, setdisableContinueOption2] = useState("");
  const [disableContinueOption3, setdisableContinueOption3] = useState("");
  const [disableContinueOption4, setdisableContinueOption4] = useState("");
  const [disableContinueOption5, setdisableContinueOption5] = useState("");
  const [displayDropdownOptions, setDisplayDropdownOptions] = useState(true);

  const [photographyUrl, setphotographyUrl] = useState<any>();
  const [pancardUrl, setpancardUrl] = useState<any>();
  const [signatureUrl, setsignatureUrl] = useState<any>();
  const [passportUrl, setPassportUrl] = useState<any>();
  const [visaUrl, setVisaUrl] = useState<any>("");
  const [InformationMessage, setInformationMessage] = useState("");
  const [backdrop, setBackDrop] = useState(false);
  const rupeeSymbol = String.fromCharCode(8377);
  const [uploadmessage, setUploadmessage] = useState("");
  const [backLoading, setBackDropLoading] = useState(false);
  const [rejectMessage, setRejectMessage] = useState("");
  const [IncomeProofDocTypeRef, setIncomeProofDocTypeRef] = useState("");
  const [bankDetails, setBankDetails] = useState({
    AccountNumber: "",
    IFSCCode: "",
  });

  const [docTypeRefData, setDocTypeRefData] = useState<any>();

  const [initialdropdowndata, setinitialdropdowndata] = useState<any>([]);

  const navigationData = routesData;

  const chequeFormat = ["png", "jpg", "jpeg"];
  const formats = ["pdf", "png", "jpg", "jpeg"];

  const handleStartOver = () => {
    confirmAlert({
      title: "",
      message:
        "Are you sure you want to restart, on pressing Yes all the Data will be deleted",
      buttons: [
        {
          label: "No",
          onClick: () => "",
        },
        {
          label: "Yes",
          onClick: () => {
            setBackDrop(true);

            startOverAPICall()
              .then((response: any) => {
                const responseData = response.data;
                //  console.log("responseData", responseData);

                setBackDrop(false);
                navigate("/");
                window.location.reload();
              })
              .catch((error: any) => {
                setBackDrop(false);
              });
          },
        },
      ],
    });
  };

  const handleStageAPI = () => {
    setloading(true);
    documentupdateAPICall()
      .then((response: any) => {
        const responseData = response.data;
        // console.log("responseData", response);
        setloading(false);
        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
      });
  };

  const handlePreview = (data: any) => {
    //console.log(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);

    let dropDowndata: any;
    setBackDropLoading(true);
    let dd_type = "document_type";
    CommonDropDownAPICall(dd_type)
      .then((response: any) => {
        const responseData = response.data;

        // console.log("photography", responseData.data);

        setDocTypeRefData(responseData.data);
      })
      .catch((error: any) => {});
    let obj: any = {
      stage: "document_upload",
    };

    stageDetailsAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;
        setBackDropLoading(false);

        dispatch(setCompletedStages(responseData?.data?.completed_stages));
        dispatch(setCurrentStage(responseData?.data?.current_stage));
        setRejectMessage(response.data.data.ErrorMessage);

        if (responseData.data.data.photography?.url) {
          setphotographyUrl(responseData.data.data.photography?.url);
          // setdisableContinueOption1("Document uploaded successfully");
        }
        if (responseData.data.data.pancard?.url) {
          setpancardUrl(responseData.data.data.pancard?.url);
          setdisableContinueOption2("Document uploaded successfully");
        }
        if (responseData.data.data.income_proof?.url) {
          setsignatureUrl(responseData.data.data.income_proof?.url);
          setdisableContinueOption3("Document uploaded successfully");
        }

        if (responseData.data.data.passport?.url) {
          setPassportUrl(responseData.data.data.passport?.url);
          setdisableContinueOption4("Document uploaded successfully");
        }
        if (responseData.data.data.visa?.url) {
          setVisaUrl(responseData.data.data.visa?.url);
          setdisableContinueOption5("Document uploaded successfully");
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setBackDropLoading(false);
      });
  }, []);

  const handleSignatureDocumentID = (data: any) => {
    if (data !== "") {
      setdisableContinueOption3("Document uploaded successfully");
      setUploadmessage("Document uploaded successfully");
      setTimeout(() => {
        setUploadmessage("");
      }, 5000);
    } else {
      setdisableContinueOption3("");
    }
  };
  const handlePassportDocumentID = (data: any) => {
    if (data !== "") {
      setdisableContinueOption4("Document uploaded successfully");
      setUploadmessage("Document uploaded successfully");
      setTimeout(() => {
        setUploadmessage("");
      }, 5000);
    } else {
      setdisableContinueOption4("");
    }
  };
  const handleVisaDocumentID = (data: any) => {
    if (data !== "") {
      setdisableContinueOption5("Document uploaded successfully");
      setUploadmessage("Document uploaded successfully");
      setTimeout(() => {
        setUploadmessage("");
      }, 5000);
    } else {
      setdisableContinueOption5("");
    }
  };

  const handlePassportPhotoDocumentID = (data: any) => {
    if (data !== "") {
      setdisableContinueOption1("Document uploaded successfully");
      setUploadmessage("Document uploaded successfully");
      setTimeout(() => {
        setUploadmessage("");
      }, 5000);
    } else {
      setdisableContinueOption1("");
    }
  };
  const handlePanDocumentID = (data: any) => {
    if (data !== "") {
      setdisableContinueOption2("Document uploaded successfully");
      setUploadmessage("Document uploaded successfully");
      setTimeout(() => {
        setUploadmessage("");
      }, 5000);
    } else {
      setdisableContinueOption2("");
    }
  };

  const dataArray: any[] = [];
  const handleDocumentID = (data: any) => {
    // console.log("documentID", data);
    setdisableContinueOption3(data);

    setUploadmessage(data);

    setTimeout(() => {
      setUploadmessage("");
    }, 5000);
    dataArray.push(data);

    const nameCounts = dataArray.reduce((countMap, name) => {
      countMap[name] = (countMap[name] || 0) + 1;
      return countMap;
    }, {});
    const uniqueNames = dataArray.filter((name) => nameCounts[name] === 1);
    // console.log("uniqueNames", uniqueNames);

    if (dataArray[0] === "Document uploaded successfully") {
    }
    if (uniqueNames.length === 3) {
    } else {
    }
  };

  return (
    <div className={uploadStyles.mainWrapperTop}>
      <SnackBar message={message} />
      {backdrop && <StartOverBackDrop />}
      <ErrorSnackBar message={rejectMessage} />
      <SucessSnackBar message={uploadmessage} />

      <div className={uploadStyles.wrapper}>
        <div
          className={uploadStyles.back}
          onClick={() => {
            navigate("/nominee");
          }}
        >
          <img src={backicon} />{" "}
          <span className={uploadStyles.backText}>Back</span>
        </div>
        <div className={uploadStyles.step}>
          <img src={keyboardicon} /> Step 8 of 10
        </div>
        <div className={uploadStyles.headerSection}>
          <p className={uploadStyles.signup}>Upload Your Documents</p>
        </div>
        {!backLoading ? (
          <div className={uploadStyles.uploadAreaContainer}>
            <div className={uploadStyles.signatureAndPan}>
              {/* <div className={uploadStyles.uploadSignatureSection}>
                <div className={uploadStyles.label}>
                  {" "}
                  <img src={passporticon} /> Passport Size Photo{" "}
                </div>
                <div>
                  <p className={uploadStyles.subText}> Passport Size Photo </p>
                </div>
                <div>
                  <FormatterCheckerBankProof
                    previewImage={handlePreview}
                    acceptedFormats={chequeFormat}
                    documentRef={
                      docTypeRefData?.photography?.document_type_reference
                    }
                    documentID={handlePassportPhotoDocumentID}
                    displayOptions={""}
                    stageDetailsData={photographyUrl}
                    name={docTypeRefData?.photography?.purpose}
                    purpose={
                      docTypeRefData?.photography?.document_type_reference
                    }
                    pdfSize={UploadSizes["passportPhoto"].pdfSize}
                    imageSize={UploadSizes["passportPhoto"].imageSize}
                  />
                </div>
              </div> */}
              <div className={uploadStyles.uploadSignatureSection}>
                <div className={uploadStyles.label}>
                  {" "}
                  <img src={panicon} />
                  Pan Card
                </div>
                <div>
                  <p className={uploadStyles.subText}> Pan Card </p>
                </div>
                <div>
                  <FormatterCheckerBankProof
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={
                      docTypeRefData?.pancard?.document_type_reference
                    }
                    documentID={handlePanDocumentID}
                    displayOptions={""}
                    stageDetailsData={pancardUrl}
                    name={docTypeRefData?.pancard?.purpose}
                    purpose={docTypeRefData?.pancard?.document_type_reference}
                    pdfSize={UploadSizes["pancard"].pdfSize}
                    imageSize={UploadSizes["pancard"].imageSize}
                  />
                </div>
              </div>
            </div>
            <div className={uploadStyles.signatureAndPan}>
              <div className={uploadStyles.uploadSignatureSection}>
                <div className={uploadStyles.label}>
                  {" "}
                  <img src={sigicon} />
                  Income Proof
                </div>
                <div>
                  <p className={uploadStyles.subText}> Income Proof </p>
                </div>
                <div>
                  <FormatterCheckerBankProof
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={
                      docTypeRefData?.income_proof?.document_type_reference
                    }
                    documentID={handleSignatureDocumentID}
                    displayOptions={""}
                    stageDetailsData={signatureUrl}
                    name={docTypeRefData?.income_proof?.purpose}
                    purpose={
                      docTypeRefData?.income_proof?.document_type_reference
                    }
                    pdfSize={UploadSizes["income_proof"].pdfSize}
                    imageSize={UploadSizes["income_proof"].imageSize}
                  />
                </div>
              </div>
              <div className={uploadStyles.uploadSignatureSection}>
                <div className={uploadStyles.label}>
                  {" "}
                  <img src={passporticon} />
                  Passport
                </div>
                <div>
                  <p className={uploadStyles.subText}>Passport </p>
                </div>
                <div>
                  <FormatterCheckerBankProof
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={
                      docTypeRefData?.passport?.document_type_reference
                    }
                    documentID={handlePassportDocumentID}
                    displayOptions={""}
                    stageDetailsData={passportUrl}
                    name={docTypeRefData?.passport?.purpose}
                    purpose={docTypeRefData?.passport?.document_type_reference}
                    pdfSize={UploadSizes["passport"].pdfSize}
                    imageSize={UploadSizes["passport"].imageSize}
                  />
                </div>
              </div>
            </div>
            <div className={uploadStyles.signatureAndPan}>
              <div className={uploadStyles.uploadVisa}>
                <div className={uploadStyles.labelVisa}>
                  {" "}
                  <img src={passporticon} />
                  Copy of VISA / Resident Permit / Employment Permit / CDC
                </div>
                <div>
                  <p className={uploadStyles.subText}>
                    {" "}
                    Copy of VISA / Resident Permit / Employment Permit / CDC{" "}
                  </p>
                </div>
                <div>
                  <FormatterCheckerBankProof
                    previewImage={handlePreview}
                    acceptedFormats={formats}
                    documentRef={docTypeRefData?.visa?.document_type_reference}
                    documentID={handleVisaDocumentID}
                    displayOptions={""}
                    stageDetailsData={visaUrl}
                    name={docTypeRefData?.visa?.purpose}
                    purpose={docTypeRefData?.visa?.document_type_reference}
                    pdfSize={UploadSizes["visa"].pdfSize}
                    imageSize={UploadSizes["visa"].imageSize}
                  />
                </div>
              </div>
            </div>

            <div className={uploadStyles.buttonStack}>
              {
              disableContinueOption1 === "Document uploaded successfully" &&
              disableContinueOption2 === "Document uploaded successfully" &&
              disableContinueOption3 === "Document uploaded successfully" &&
              disableContinueOption4 === "Document uploaded successfully" &&
              disableContinueOption5 === "Document uploaded successfully" ? (
                <LoadingButton
                  variant="contained"
                  onClick={handleStageAPI}
                  loading={loading}
                  id="upLoadDocumentsContinueButton"
                  className={uploadStyles.approveButton}
                  style={{ height: "50px" }}
                >
                  {" "}
                  Continue
                </LoadingButton>
              ) : (
                <LoadingButton
                  variant="contained"
                  // onClick={handleStageAPI}
                  loading={loading}
                  disabled
                  id="upLoadDocumentsContinueButton"
                  className={uploadStyles.approveButton}
                  style={{ height: "50px" }}
                >
                  {" "}
                  Continue
                </LoadingButton>
              )}

              {/* <div className={uploadStyles.startOverSection}>
                <img src={icon} className={uploadStyles.iconImage} />
                <p className={uploadStyles.paratext}>
                  {" "}
                  if the above mentioned info not yours
                  <span
                    className={uploadStyles.startoverbutton}
                    onClick={handleStartOver}
                  >
                    Start Over
                  </span>
                </p>
              </div> */}
            </div>
          </div>
        ) : (
          <div style={{ height: "65vh" }}>
            <BackDrop />
          </div>
        )}
      </div>
    </div>
  );
}
